import { Component } from '@angular/core';
import { BannerComponent } from '@spartacus/storefront';
import { EfaGenericLinkComponent } from '../efa-generic-link/efa-generic-link.component';
import { EfaMediaComponent } from '../efa-media/efa-media.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-banner',
    templateUrl: './efa-banner.component.html',
    imports: [EfaGenericLinkComponent, EfaMediaComponent, AsyncPipe]
})
export class EfaBannerComponent extends BannerComponent {}
